import { v4 as ukey } from "uuid";
import "./style.css"
import { presentationData } from "./PresentationData";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useContext } from "react";
import WindowSizeContext from "../../utils/WindowSizeContext"

const Presentation = (props) => {

    const clickHandler = (e, url) => {
        if (e.ctrlKey) {
            window.open(url, "_blank", "noreferrer");
        }
        else {
            window.open(url, "_self");
        }
    }

    const citiesItems = presentationData.map(city => {
        return (
            <div className={"city-item " + city.id} key={ukey()} onClick={(e) => clickHandler(e, city.link)}>
                <p className="city-title">{city.title}</p>
            </div>
        )
    }).filter((item) => item !== undefined);


    const size = useContext(WindowSizeContext);


    const calcItemsNum = () => {
        return size.width >= 1150 ? 6 : 5;
    }

    return <>
        <div className="presentation-container">
            <p className="presesntation-header">
                Презентации
            </p>
            <div className="cities-container">
                {size.width > 990 ?
                    <AliceCarousel
                        autoHeight={false}
                        autoWidth={false}
                        autoPlay={true}
                        animationDuration={1800}
                        mouseTracking={true}
                        controlsStrategy="responsive"
                        disableButtonsControls={true}
                        disableDotsControls={true}
                        infinite={true}
                        responsive={{ 0: { items: calcItemsNum() } }}
                        items={citiesItems}
                    /> : citiesItems}
            </div>
        </div>
    </>
}

export default Presentation;